const never = (x) => `Something went wrong (${JSON.stringify(x)}).`;
// Single source of friendly copy for every error the UI can surface (Doc 04 §6).
// The switch is compile-time exhaustive: adding a new error kind breaks the build
// here until copy is provided.
export const errorToMessage = (e) => {
    if (typeof e === "string") {
        switch (e) {
            case "WrongPassword":
                return "That password doesn't match. Try again.";
            case "EmailInUse":
                return "An account with that email already exists.";
            case "WeakPassword":
                return "Choose a stronger password (at least 6 characters).";
            case "RequiresRecentLogin":
                return "Please sign in again to make this change.";
            case "UserNotFound":
                return "No account found for that email.";
            case "Network":
                return "You appear to be offline. Check your connection.";
            case "PopupClosed":
                return "Sign-in was canceled before it finished.";
            case "AccountExistsWithDifferentCredential":
                return "An account already exists for that email using a different sign-in method.";
            case "ProviderDisabled":
                return "That sign-in method isn't enabled.";
            case "NoPasswordCredential":
                return "This account doesn't use a password — manage sign-in from your provider.";
            case "LastSignInMethod":
                return "You can't remove your only sign-in method.";
            default:
                return never(e);
        }
    }
    switch (e.kind) {
        case "NotFound":
            return `That ${e.entity} no longer exists.`;
        case "PermissionDenied":
            return `You don't have permission to ${e.action}.`;
        case "Conflict":
            return e.detail;
        case "Corrupt":
            return "This data looks corrupted and couldn't be loaded.";
        case "Network":
            return "You appear to be offline. Check your connection.";
        case "InviteInvalid":
            return "This invite link is invalid or has expired.";
        case "Validation":
            return e.details.join(" ");
        default:
            return never(e);
    }
};
//# sourceMappingURL=errorToMessage.js.map